export enum ClinicInvoiceServiceType {
  RPM = 'rpm',
  CCM = 'ccm',
  COMPLEX_CCM = 'complex_ccm',
  BHI = 'bhi',
}
